import { z } from "zod";

export const PopularTrendingTokenSchema = z.object({
  id: z.string().optional(),
  symbol: z.string(),
  name: z.string().optional(),
  marketCapRank: z.number().int().nullable().optional(),
});

export const PopularTrendingTokensResponseSchema = z.object({
  tokens: z.array(PopularTrendingTokenSchema),
  updatedAt: z.string(),
});

export type PopularTrendingToken = z.infer<typeof PopularTrendingTokenSchema>;
export type PopularTrendingTokensResponse = z.infer<typeof PopularTrendingTokensResponseSchema>;
